<template>
  <!--自己負責更新即可,不用串連跳轉沒有login複雜-->
  <div>
    <populate-form
      :formTitle="role_type_name+'設定修改'+(profileTarget!=='merchant'?'-目前不開放修改':'')"
      fkey="pf01"
      ref="profileForm"
      populateOptionVar="formOptions"
      formDataObjVar="formData"
    ></populate-form>
  </div>
</template>

<script>
import {
  apiUpdateSelfProfile 
} from '@/api/Merchant.js'

export default {
  name: 'Profile',
  data: function () {
    return {
      waiting:false,
      newPwd:"",
      renewPwd:"",
      formData: {},
      formOptions: [
        {
          componentType:"span",
          akey:"span1",
          col:3,
          placeholder:"姓名"
        },
        {
          componentType:"text",
          akey:"name",
          col:7,
          disabled:this.profileTarget==='user',
        },
        {
          componentType:"span",
          akey:"span2",
          col:3,
          placeholder:"新密碼"
        },
        {
          componentType:"password",
          akey:"newPwd",
          defaultValue:"",
          placeholder:"不修改密碼不用輸入",
          col:7,
          disabled:this.profileTarget==='user',
        },
        {
          componentType:"span",
          akey:"span3",
          col:3,
          placeholder:"再輸入一次"
        },
        {
          componentType:"password",
          akey:"renewPwd",
          defaultValue:"",
          placeholder:"需和上面的密碼完全相同",
          col:7,
          disabled:this.profileTarget==='user',
        },
        {
          componentType:"span",
          //akey:"span4",//用不到不用設定啊
          col:3,
        },
        {
          componentType:"b-button",
          //akey:"btn1",
          col:3,
          placeholder:"取消",
          execCallback:this.cancel
        },
        {
          componentType:"b-button",
          //akey:"btn2",
          col:4,
          placeholder:"更新設定",
          disabled:(this.profileTarget==='user'),
          title:(this.profileTarget==='user'?'目前不開放在此修改帳號密碼':''),
          execCallback:this.resetPwd
        },
      ],
      errorPrompt: String,
      dismissSecs: 5,
      dismissCountDown: 0,
    }
  },
  props: [
    'profileTarget',
    'CancelCallback'
    ],
  methods: {
    initialize: function () {
      this.waiting = false
      this.$refs.profileForm.initDefault()
      setTimeout(() => {
        this.formData.name = this.$bus.session.name
        this.formData.newPwd = ""
        this.formData.renewPwd = ""
        this.$refs.profileForm.refreshModelVar()
        this.$refs.profileForm.setFocus('newPwd')
      }, 50);
    },
    resetPwd () {
      if (this.formData.name.trim() === '') {
        this.$refs.profileForm.triggerAlert("姓名不能空白")
        return
      }
      let Param = {
        method: 'update_self_profile'
      }
      if (this.profileTarget === 'merchant') {
        Param.module = 'merchant'
        Param.account_name = this.formData.name
      }
      else if (this.profileTarget === 'admin') {
        Param.module = 'admin_manage'
        Param.name = this.formData.name
      }
      if (this.formData.newPwd.trim() !== '') {
        if (this.formData.newPwd !== this.formData.renewPwd) {
          this.$refs.profileForm.triggerAlert("兩次密碼不一致")
          return
        }
        Param.password = this.formData.newPwd
      }
      let vm = this
      apiUpdateSelfProfile(Param).then(function(resp){
        vm.dismissCountDown = 0
        vm.$bus.session.name = vm.formData.name
        vm.$refs.profileForm.triggerAlert(vm.formData.newPwd?"密碼重設完成":"更新完成")
        setTimeout(() => {
          vm.CancelCallback()
        }, 1000);
      }).catch(function(error){
        let data = error.response.data
        vm.dismissCountDown = 0
        if (data.ok === 0) {
          this.$refs.profileForm.triggerAlert(data.msg)
          vm.waiting = false
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   vm.dismissCountDown = 0
      //   if (data.ok === 0) {
      //     this.$refs.profileForm.triggerAlert(data.msg)
      //     vm.waiting = false
      //     return
      //   }
      //   vm.$bus.session.name = vm.formData.name
      //   vm.$refs.profileForm.triggerAlert(vm.formData.newPwd?"密碼重設完成":"更新完成")
      //   setTimeout(() => {
      //     vm.CancelCallback()
      //   }, 1000);
      // },this)
    },
    cancel: function () {
      this.CancelCallback();
    },
  },
  computed: {
    role_type_name () {
      if (!this.$bus.session) {
        return '...未登入...'
      }
      if (this.$bus.getRole() === 'admin') {
        switch (this.$bus.session.role_type) {
          case 'sys_admin':
            return '系統管理者'
          case 'sales_mgr':
          case 'sales':
            return '業務後台管理者'
          case 'support_mgr':
          case 'support':
            return '客服後台管理者'
        }
      }
      else if (this.$bus.getRole() === 'merchant' || this.$bus.getRole() === 'spalogin') {
        return (this.$bus.session.is_super_manage?'供應商':'店家')+(this.$bus.session.account_type==='admin'?'主管理者':(this.$bus.session.account_type==='manager'?'預約劃位管理者':'美容師'))
      }
      else if (this.$bus.getRole() === 'user') {
        return '會員'
      }
    }
  },
  created: function () {
    this.waiting = false
    // 不管是在created還是mounted直接設focus都無效,必須timeout等一下
    setTimeout(() => {
      this.$refs.profileForm.setFocus('newPwd')
    }, 500);
    // foucs on account
    // eslint-disable-next-line
    // console.log(this.$refs)
    //
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enter-waiting {
  cursor:wait;
}
</style>
